import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["displayName", "href", "isEditable", "onClick", "showTooltip", "size", "socialNetwork", "tooltipPlacement", "tooltipTitle", "type"];
import { Component } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';

// @ts-expect-error - bender-url is not typed
import defaultCompanyImage from 'bender-url!avatar-components/images/default-company-avatar.png';
// @ts-expect-error - bender-url is not typed
import defaultContactImage from 'bender-url!avatar-components/images/default-avatar.png';
import { AVATAR_SOURCE_TYPES, AVATAR_TYPES, AVATAR_TYPE_ICONS } from '../Constants';
import { delayUntilIdle } from '../lib/delayUntilIdle';
import AvatarContentHolder from './baseStyledComponents/AvatarContentHolder';
import SVGIcon from './baseStyledComponents/SVGIcon';
import SVGImage from './baseStyledComponents/SVGImage';
import SVGText from './baseStyledComponents/SVGText';
import AvatarHover from './baseStyledComponents/AvatarHover';
import { Text } from 'foundations-components/components/Text';
import { getMarginProps, getBorderProps } from '../lib/stylePropHelpers';
import { AvatarEditOverlay } from './baseStyledComponents/AvatarEditOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export class AvatarDisplay extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isTooltipLoaded: false
    };
  }
  componentDidMount() {
    this.cancelTimeout = delayUntilIdle(() => this.setState({
      isTooltipLoaded: true
    }));
  }
  componentWillUnmount() {
    if (this.cancelTimeout) this.cancelTimeout();
  }
  getDefaultAvatar(type) {
    if (!type) {
      return undefined;
    } else if (type === 'company') {
      return defaultCompanyImage;
    } else if (type === 'contact') {
      return defaultContactImage;
    }
    return undefined;
  }
  tryToGetANameOutOfEmailAddress(aString) {
    if (!aString || !aString.indexOf('@')) {
      return aString;
    }
    return aString.split('_').join(' ');
  }
  isLatinCharacters(aString) {
    const nonLatin = /[^\u0020-\u01BF]/;
    return nonLatin.test(aString);
  }
  displayNameToInitials(aString, passed) {
    const {
      displayName,
      size,
      type
    } = this.props;
    if (passed || !aString || typeof aString !== 'string') {
      const defaultSrc = this.getDefaultAvatar(type);
      return /*#__PURE__*/_jsx(SVGImage, {
        size: size,
        src: defaultSrc,
        "data-source": defaultSrc ? type === 'company' ? AVATAR_SOURCE_TYPES.DEFAULT_COMPANY_AVATAR : AVATAR_SOURCE_TYPES.DEFAULT_CONTACT_AVATAR : undefined
      });
    }
    if (!aString || this.isLatinCharacters(aString) && !passed) {
      return this.displayNameToInitials(this.tryToGetANameOutOfEmailAddress(displayName), true);
    }
    const names = aString.split(' ');
    let initials = names[0].substring(0, 1);
    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1);
    }
    return /*#__PURE__*/_jsx(SVGText, {
      size: size,
      y: "55",
      children: initials
    });
  }
  renderAvatarImageOrText() {
    const {
      src,
      displayName,
      type,
      size
    } = this.props;
    if (src) {
      return /*#__PURE__*/_jsx(SVGImage, {
        size: size,
        src: src,
        "data-source": AVATAR_SOURCE_TYPES.KNOWN_SRC
      });
    }
    const typeValue = type ? AVATAR_TYPES[type] : undefined;
    if (typeValue === AVATAR_TYPES.company) {
      const defaultSrc = this.getDefaultAvatar(type);
      return /*#__PURE__*/_jsx(SVGImage, {
        size: size,
        src: defaultSrc,
        "data-source": defaultSrc ? AVATAR_SOURCE_TYPES.DEFAULT_COMPANY_AVATAR : undefined
      });
    } else if (typeValue === AVATAR_TYPES.contact || typeValue === AVATAR_TYPES.company) {
      return this.displayNameToInitials(displayName);
    }
    return /*#__PURE__*/_jsx(SVGIcon, {
      size: size,
      y: 65,
      icon: AVATAR_TYPE_ICONS[typeValue]
    });
  }
  renderAvatarContent() {
    const _this$props = this.props,
      {
        displayName,
        href,
        isEditable,
        onClick,
        showTooltip,
        size,
        socialNetwork,
        tooltipPlacement,
        tooltipTitle,
        type
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const borderProps = getBorderProps(rest);
    const marginProps = getMarginProps(rest);
    const maybeWrapperProps = Object.assign({
      isEditable,
      isTooltipLoaded: this.state.isTooltipLoaded,
      onClick,
      showTooltip,
      tooltipPlacement,
      tooltipTitle: tooltipTitle || displayName
    }, marginProps);
    return /*#__PURE__*/_jsx(AvatarHover, Object.assign({}, maybeWrapperProps, {
      children: /*#__PURE__*/_jsxs(AvatarContentHolder, Object.assign({
        "data-test-id": "AvatarDisplay-avatarContentHolder",
        href: href,
        size: size,
        socialNetwork: socialNetwork,
        type: type
      }, borderProps, {
        children: [this.renderAvatarImageOrText(), isEditable ? /*#__PURE__*/_jsx(AvatarEditOverlay, {}) : null]
      }))
    }));
  }
  render() {
    const {
      children,
      onClick,
      childMarginInlineStart,
      childTruncateLength
    } = this.props;
    const avatarComponent = this.renderAvatarContent();
    return children ? /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [avatarComponent, /*#__PURE__*/_jsx(Text, {
        as: "span",
        "data-test-id": "AvatarDisplay-truncateString-children",
        marginInlineStart: childMarginInlineStart,
        children: /*#__PURE__*/_jsx(TruncateString, {
          onClick: onClick,
          maxWidth: childTruncateLength,
          "data-test-id": "AvatarDisplay-truncateString",
          children: children
        })
      })]
    }) : avatarComponent;
  }
}
AvatarDisplay.defaultProps = {
  showTooltip: true,
  size: 'sm',
  childMarginInlineStart: '300',
  childTruncateLength: 200
};